import React, { Component } from 'react';

import { buildPath } from '../utils/route_utils';
import '../css/OpenSlideShow.css';

class OpenSlideShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      current_lang: this.props.lang,
      animationComplete: false,
      slideContent: {
        "zh": "Nexuni 耐思尼致力於打造核心大腦推動 AI 機器人的落地，解決產業缺工問題。",
        "en": "We develop the core AI brain that orchestrates multimodal sensing and drives any robot, accelerating real-world deployment to solve industrial labor shortages.",
        "ja": "コアAIブレインでロボットの実導入を加速し、産業の人手不足を解消する。"
      },
      valueProp: {
        "zh": "AI Robots, Ready to Work.",
        "en": "AI Robots, Ready to Work.",
        "ja": "AI Robots, Ready to Work."
      },
      ctaText: {
        "zh": "探索產品",
        "en": "Explore Products",
        "ja": "製品を見る"
      },
      announcementTag: {
        "zh": "最新",
        "en": "NEW",
        "ja": "新着"
      },
      announcement: {
        "zh": "Nexuni首度登黃仁勳GTC公布的台灣供應鏈名單",
        "en": "Nexuni debuts on Jensen Huang's GTC Taiwan supply chain list",
        "ja": "Nexuni、ジェンスン・フアン氏のGTC台湾サプライチェーン一覧に初登場"
      },
    }
  }

  componentDidMount() {
    this.animTimer = setTimeout(() => {
      this.setState({ animationComplete: true });
    }, 5500);
  }

  componentWillUnmount() {
    if (this.animTimer) clearTimeout(this.animTimer);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.current_lang) {
      this.setState({ current_lang: nextProps.lang });
    }
  }

  render() {
    const lang = this.state.current_lang;
    const letters = [
      { id: 'n1', src: '/assets/mainpage_nexuni_n.svg', alt: 'N', startX: -35, startY: -30 },
      { id: 'e',  src: '/assets/mainpage_nexuni_e.svg', alt: 'E', startX: 25,  startY: -35 },
      { id: 'x',  src: '/assets/mainpage_nexuni_x.svg', alt: 'X', startX: -20, startY: 40 },
      { id: 'u',  src: '/assets/mainpage_nexuni_u.svg', alt: 'U', startX: 30,  startY: 35 },
      { id: 'n2', src: '/assets/mainpage_nexuni_n.svg', alt: 'N', startX: -40, startY: 15 },
      { id: 'i',  src: '/assets/mainpage_nexuni_i.svg', alt: 'I', startX: 38,  startY: -20 },
    ];

    return (
      <div className="hero-section">
        {/* Background video — fades in behind the persisting logo */}
        <div className="hero-video-bg" style={{ animation: 'fade-in 1.5s ease 3.7s forwards' }}>
          <video autoPlay muted loop playsInline>
            <source src="/video/main_video.mp4" type="video/mp4" />
          </video>
          <div className="hero-video-overlay"></div>
        </div>

        {/* Grid pattern overlay */}
        <div className="hero-grid-pattern"></div>

        {/* X split animation */}
        <div className="hero-x-split">
          <img
            className="hero-x-left"
            src="/assets/mainpage_nexuni_opening_l.svg"
            alt="X-left"
            style={{ animation: 'move-right 1.5s ease 0s forwards, fade-out 1.5s ease 0.75s forwards' }}
          />
          <img
            className="hero-x-right"
            src="/assets/mainpage_nexuni_opening_r.svg"
            alt="X-right"
            style={{ animation: 'move-left 1.5s ease 0s forwards, fade-out 1.5s ease 0.75s forwards' }}
          />
        </div>

        {/* Logo group — fades out after letters converge */}
        <div className="hero-logo-group" style={{ animation: 'logo-settle 0.8s ease 3.7s forwards' }}>
          <div className="hero-letters">
            {letters.map((letter) => (
              <div
                className={"hero-letter-container" + (letter.id === 'i' ? " hero-letter-i" : "")}
                key={letter.id}
                style={{
                  '--start-x': letter.startX + 'vw',
                  '--start-y': letter.startY + 'vh',
                }}
              >
                <img
                  className="hero-letter-svg"
                  src={letter.src}
                  alt={letter.alt}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Announcement pill pinned near the top of the video */}
        <a
          className="hero-announcement"
          href={buildPath(lang, '/about/news')}
          style={{ animation: 'hero-announcement-in 0.8s ease 4.1s forwards, hero-announcement-pulse 2.2s ease-in-out 5s infinite' }}
        >
          <span className="hero-announcement__tag">{this.state.announcementTag[lang]}</span>
          <span className="hero-announcement__text">{this.state.announcement[lang]}</span>
          <span className="hero-announcement__arrow" aria-hidden="true">&rarr;</span>
        </a>

        {/* Content revealed below the logo */}
        <div className="hero-content" style={{ animation: 'hero-content-in 1s ease 3.9s forwards' }}>
          <h1 className="hero-value-prop">{this.state.valueProp[lang]}</h1>
          <p className="hero-sub-text">{this.state.slideContent[lang]}</p>
          <button className="hero-cta" onClick={() => this.props.navigate('/solutions')}>
            {this.state.ctaText[lang]}
          </button>
        </div>

        {/* Scroll indicator — double chevron pointing down */}
        {this.state.animationComplete && (
          <div className="hero-scroll-indicator" aria-hidden="true">
            <span className="hero-scroll-chevron" />
            <span className="hero-scroll-chevron" />
          </div>
        )}
      </div>
    );
  }
}

export default OpenSlideShow;
